// Graph Component
import { useState } from "react";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { MdOutlineMonitorWeight } from "react-icons/md";
import { FaWeight } from "react-icons/fa";
import { RiPinDistanceFill, RiFireLine } from "react-icons/ri";
import { FaTshirt } from "react-icons/fa";
import { GiBodyHeight, GiUnderwearShorts } from "react-icons/gi";
import footprint from "../assets/footprint-fill.png";
import ChestIcon from "../assets/ChestIcon.png";
import WaistIcon from "../assets/WaistIcon.png";

interface ApexChartProps {
  type: "bar" | "line";
  series: Array<{ name: string; data: number[] }>;
  categories: string[];
  selectedMetric: string;
  onMetricChange: (metric: string) => void;
  bodyUnits: {
    weight: string;
    height: string;
    chest: string;
    waist: string;
  };
}

const LineGraph: React.FC<ApexChartProps> = ({
  type,
  series,
  categories,
  onMetricChange,
  bodyUnits,
}) => {
  // --- THEME LOGIC START ---
  const [chartKey, setChartKey] = useState(0);

  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      setChartKey((prev) => prev + 1);
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["style"] });
    return () => observer.disconnect();
  }, []);

  const textColor = getComputedStyle(document.documentElement).getPropertyValue("--text-color").trim();
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue("--svg-color").trim();
  const secondaryColor = getComputedStyle(document.documentElement).getPropertyValue("--legend-color").trim();
  // --- THEME LOGIC END ---
  const [currentMetric, setCurrentMetric] = useState("Weight");

  console.log("series:", series);
  console.log("categories:", categories);
  console.log("type:", type);

  const handleMetricChange = (metric: string) => {
    setCurrentMetric(metric);
    onMetricChange(metric);
  };
  // const metricUnits: Record<string, string> = {
  //   Weight: "Weight (kg)",
  //   Height: "Height (cm)",
  //   Waist: "Waist (cm)",
  //   Chest: "Chest (cm)",
  // };
  const metricUnits: Record<string, string> = {
    Weight: `Weight (${bodyUnits.weight})`,
    Height: `Height (${bodyUnits.height})`,
    Waist: `Waist (${bodyUnits.waist})`,
    Chest: `Chest (${bodyUnits.chest})`,
  };


  const options: ApexCharts.ApexOptions = {
    chart: {
      type: type,
      height: 250,
      stacked: true,
      foreColor: textColor, // Dynamic text color
      toolbar: { show: false },
      zoom: { enabled: true },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 5,
        columnWidth: "10%",
      },
    },
    xaxis: {
      categories: categories,
      tickPlacement: "between",
      labels: {
        style: { colors: textColor, fontSize: "10px" },
        rotate: 0,
        trim: false,
        hideOverlappingLabels: true,
        offsetX: 0,
      },
    },
    grid: {
      padding: { left: 0, right: 0 },
      borderColor: getComputedStyle(document.documentElement).getPropertyValue("--line-color").trim() || "#e0e0e0", // Optional: style grid lines
    },
    yaxis: {
      title: { text: "" },
      labels: { style: { colors: textColor } },
      max:
        currentMetric === "Weight"
          ? 150
          : currentMetric === "Height"
            ? 200
            : currentMetric === "Waist"
              ? 120
              : currentMetric === "Chest"
                ? 140
                : 60,
      tickAmount: 5,
      min: 0,
    },
    fill: {
      opacity: 1,
      colors: [primaryColor, secondaryColor], // Dynamic fill
    },
    markers: { size: 2 },
    colors: [primaryColor, secondaryColor], // Dynamic stroke/marker colors
    dataLabels: { enabled: false },
    legend: { show: false },
    tooltip: {
      theme: "dark",
      shared: true,
      intersect: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: { position: "bottom", offsetX: -10, offsetY: 0 },
        },
      },
    ],
  };

  return (
    <div className="graph-container">
      <div className="MetricToggleContainer">
        <div className="MetricLabel">{metricUnits[currentMetric]}</div>
        <div className="Metric-Icons">
          <button
            className={`GraphIcon ${currentMetric === "Weight" ? "active" : ""
              }`}
            onClick={() => handleMetricChange("Weight")}
          >
            <FaWeight
              color="white"
              style={{ height: "1.4rem", width: "1.2rem" }}
            />
          </button>
          <button
            className={`GraphIcon ${currentMetric === "Height" ? "active" : ""
              }`}
            onClick={() => handleMetricChange("Height")}
          >
            <GiBodyHeight
              color="white"
              style={{ height: "1.4rem", width: "1.2rem" }}
            />
          </button>
          <button
            className={`GraphIcon ${currentMetric === "Waist" ? "active" : ""}`}
            onClick={() => handleMetricChange("Waist")}
          >
            <img
              src={WaistIcon}
              color="white"
              style={{ height: "1.4rem", width: "1.2rem" }}
            />
          </button>
          <button
            className={`GraphIcon ${currentMetric === "Chest" ? "active" : ""}`}
            onClick={() => handleMetricChange("Chest")}
          >
            <img
              src={ChestIcon}
              color="white"
              style={{ height: "1.4rem", width: "1.2rem" }}
            />
          </button>
        </div>
      </div>
      <ReactApexChart
        key={chartKey}
        options={options}
        series={series}
        type={type}
        height={200}
      />
    </div>
  );
};

export default LineGraph;
